import type { TimePeriod } from './types';

/**
 * Pads a number with a leading zero if needed.
 */
export const padWithZero = (number: number): string =>
  String(number).padStart(2, '0');

/**
 * Converts 12-hour format to 24-hour format.
 * - 12:00 AM (midnight) → 0
 * - 1:00 AM - 11:00 AM → 1-11
 * - 12:00 PM (noon) → 12
 * - 1:00 PM - 11:00 PM → 13-23
 */
export const to24Hour = (hour12: number, period: TimePeriod): number => {
  if (period === 'AM') {
    return hour12 === 12 ? 0 : hour12;
  }
  return hour12 === 12 ? 12 : hour12 + 12;
};

/**
 * Converts 24-hour format to 12-hour format with period.
 */
export const to12Hour = (
  hour24: number,
): { hour: number; period: TimePeriod } => ({
  hour: hour24 % 12 || 12,
  period: hour24 >= 12 ? 'PM' : 'AM',
});

/**
 * Clamps a parsed numeric value within a range.
 * Returns min if parsing fails (NaN).
 */
export const clampValue = (value: string, min: number, max: number): number => {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return min;
  }
  return Math.max(min, Math.min(max, parsed));
};
